// eslint-disable-next-line @nx/enforce-module-boundaries
import { DropdownRequest } from '@cigna/pdl-viewer/drug-search/data-access';

export const dateToSyncLists = '2025-01-01';
export const dateToSyncTierLists = '2023-01-01';

const stateFiveTierlLabel = 'Cigna 5-Tier Plan Drug List';
const stateFourTierLabel = 'CMS Standard 4-Tier Plan Drug List';

export const nyStates: DropdownRequest[] = [
  {
    value: 'STBPL049',
    display: 'Arizona',
    code: 'AZ',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL049',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL096',
      },
    ],
  },
  {
    value: 'STBPL055',
    display: 'Colorado',
    code: 'CO',
  },
  {
    value: 'STBPL056',
    display: 'Florida',
    code: 'FL',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL056',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL102',
      },
    ],
  },
  {
    value: 'STBPL065',
    display: 'Georgia',
    code: 'GA',
  },
  {
    value: 'STBPL052',
    display: 'Illinois',
    code: 'IL',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL052',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL099',
      },
    ],
  },
  {
    value: 'STBPL068',
    display: 'Indiana',
    code: 'IN',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL068',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL107',
      },
    ],
  },
  {
    value: 'STBPL067',
    display: 'Mississippi',
    code: 'MS',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL067',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL106',
      },
    ],
  },
  {
    value: 'STBPL054',
    display: 'North Carolina',
    code: 'NC',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL054',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL101',
      },
    ],
  },
  {
    value: 'STBPL053',
    display: 'Tennessee',
    code: 'TN',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL053',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL100',
      },
    ],
  },
  {
    value: 'STBPL070',
    display: 'Texas',
    code: 'TX',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL070',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL109',
      },
    ],
  },
  {
    value: 'STBPL050',
    display: 'Virginia',
    code: 'VA',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL050',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL097',
      },
    ],
  },
];

export const cdStates: DropdownRequest[] = [
  {
    value: 'STBPL049',
    display: 'Arizona',
    code: 'AZ',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL049',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL096',
      },
    ],
  },
  {
    value: 'STBPL055',
    display: 'Colorado',
    code: 'CO',
  },
  {
    value: 'STBPL056',
    display: 'Florida',
    code: 'FL',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL056',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL102',
      },
    ],
  },
  {
    value: 'STBPL065',
    display: 'Georgia',
    code: 'GA',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL065',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL105',
      },
    ],
  },
  {
    value: 'STBPL052',
    display: 'Illinois',
    code: 'IL',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL052',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL099',
      },
    ],
  },
  {
    value: 'STBPL068',
    display: 'Indiana',
    code: 'IN',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL068',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL107',
      },
    ],
  },
  {
    value: 'STBPL067',
    display: 'Mississippi',
    code: 'MS',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL067',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL106',
      },
    ],
  },
  {
    value: 'STBPL054',
    display: 'North Carolina',
    code: 'NC',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL054',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL101',
      },
    ],
  },
  {
    value: 'STBPL066',
    display: 'Pennsylvania',
    code: 'PA',
  },
  {
    value: 'STBPL069',
    display: 'South Carolina',
    code: 'SC',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL069',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL108',
      },
    ],
  },
  {
    value: 'STBPL053',
    display: 'Tennessee',
    code: 'TN',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL053',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL100',
      },
    ],
  },
  {
    value: 'STBPL070',
    display: 'Texas',
    code: 'TX',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL070',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL109',
      },
    ],
  },
  {
    value: 'STBPL058',
    display: 'Utah',
    code: 'UT',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL058',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL104',
      },
    ],
  },
  {
    value: 'STBPL050',
    display: 'Virginia',
    code: 'VA',
    drugTypes: [
      {
        label: stateFiveTierlLabel,
        value: 'STBPL050',
      },
      {
        label: stateFourTierLabel,
        value: 'STBPL097',
      },
    ],
  },
];

export const drugTier: DropdownRequest[] = [
  {
    value: 'STBPL041',
    display: 'Advantage 3 Tier',
  },
  {
    value: 'STBPL017',
    display: 'Legacy 3 Tier',
  },
  {
    value: 'STBPL025',
    display: 'Performance 3 Tier',
  },
  {
    value: 'STBPL001',
    display: 'Standard 3 Tier',
  },
  {
    value: 'STBPL009',
    display: 'Value 3 Tier',
  },
];

export const nyDrugTier: DropdownRequest[] = [
  {
    value: 'STBPL041',
    display: 'Advantage 3 Tier',
  },
  {
    value: 'STBPL017',
    display: 'Legacy 3 Tier',
  },
  {
    value: 'STBPL072',
    display: 'National Preferred 3 Tier',
  },
  {
    value: 'STBPL080',
    display: 'National Preferred 4 Tier',
  },
  {
    value: 'STBPL076',
    display: 'National Preferred 4 Tier Specialty',
  },
  {
    value: 'STBPL088',
    display: 'National Preferred 5 Tier',
  },
  {
    value: 'STBPL084',
    display: 'National Preferred 5 Tier Specialty',
  },
  {
    value: 'STBPL092',
    display: 'National Preferred 6 Tier',
  },
  {
    value: 'STBPL025',
    display: 'Performance 3 Tier',
  },
  {
    value: 'STBPL001',
    display: 'Standard 3 Tier',
  },
  {
    value: 'STBPL009',
    display: 'Value 3 Tier',
  },
];
